import React from 'react';
import classNames from 'classnames';
import Typography, { Variant } from '@lib/components/Typography/Typography';
import Collapse from '@lib/components/Collapse/Collapse';
import { IconName, ModalIconColor } from '@lib/components/Modal/enums';
import ModalIcon from './ModalIcon';
import styles from './Modal.module.scss';

export interface ModalBodyProps {
  icon?: IconName;
  iconColor?: ModalIconColor;
  title?: React.ReactNode;
  titleAlign?: 'left' | 'center';
  titleVariant?: Variant;
  description?: React.ReactNode;
  descriptionAlign?: 'left' | 'center';
  descriptionChildren?: React.ReactNode;
  children?: React.ReactElement;
  actions?: React.ReactElement;
  modalBodyClassName?: string;
  modalContentClassName?: string;
}

function ModalBody(props: ModalBodyProps) {
  const {
    icon,
    iconColor = ModalIconColor.Blue,
    title,
    titleAlign = 'center',
    titleVariant = 'h2',
    description,
    descriptionAlign = 'center',
    descriptionChildren,
    children,
    actions,
    modalBodyClassName,
    modalContentClassName,
  } = props;

  const hasModalTopRender = !!(
    icon ||
    title ||
    description ||
    descriptionChildren
  );

  return (
    <div className={classNames(styles.modalBody, modalBodyClassName)}>
      {hasModalTopRender ? (
        <div>
          {icon && (
            <div className={styles.modalIcon}>
              <ModalIcon icon={icon} iconColor={iconColor} />
            </div>
          )}
          {title && (
            <Collapse minHeight={120} useCropBlurWhite>
              <Typography
                variant={titleVariant}
                strong
                className={classNames(styles.modalTitle, {
                  [styles.modalTitleLeft]: titleAlign === 'left',
                  [styles.modalTitleCenter]: titleAlign === 'center',
                })}
              >
                {title}
              </Typography>
            </Collapse>
          )}
          {description && (
            <Typography
              variant="body"
              className={classNames(styles.modalDescription, {
                [styles.modalDescriptionCentered]:
                  descriptionAlign === 'center',
              })}
            >
              {description}
            </Typography>
          )}
          {descriptionChildren && <div>{descriptionChildren}</div>}
        </div>
      ) : null}
      {children !== undefined && (
        <div className={classNames(styles.modalContent, modalContentClassName)}>
          {children}
        </div>
      )}
      {actions !== undefined && (
        <div className={styles.modalActions}>{actions}</div>
      )}
    </div>
  );
}

export default ModalBody;
